
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import AddressInput from './AddressInput';

const AddressInputController = ({
  name = "registered_address",
  label = "Address",
  maxaddrs = 1,
  addresstype='',
  sx = {},
  value,
  helptext,

}) => {

  const { control, setValue, formState: { errors } } = useFormContext();
  const registered_address = useWatch({ control, name: 'registered_address' });

    const updateFields = (name, e) => {
      setValue(name, e.addrdata); // company_number
    }
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      label={label}
      maxaddrs={1}
      sx={sx}
      addresstype={addresstype}
      render={({ field }) => (
        <AddressInput
          {...field}
          label={label}
          maxaddrs={maxaddrs}
          errors={errors}
          sx={sx}
          name={name}
          addresstype={addresstype}
          registered_address={registered_address}
          helptext={helptext}
          onChange={(e) => {
            // Set both fields
            updateFields(field.name, e); // company_number
          }}
        />
      )}
    />
  );
};

export default AddressInputController;
